module.exports = __webpack_public_path__ + "static/media/tablet-android.1b40b825.svg";